import uly from "ulysses/base";
import $ from "jquery";
import ko from "knockout";
import L from "leaflet";
import cilogi from "cilogi-marker";
import HalResource from "../api";
import markup from "ulysses/widgets/map.html";
import "../widgets";

$(document).ready(function() { $(markup).appendTo($("body")); });
/* Look at https://github.com/leaflet-extras for real stuff
*/
var DEFAULT_TILES = "osm-mapnik";
var tile_layers = {
    "osm-mapnik":{
        "url":"https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png",
        "options":{
            "attribution":
 "&copy; <a href=\"https://www.openstreetmap.org/copyright\">OpenStreetMap</a> contributors."
        }
    },
    "osm-mapnik-bw":{
        "url":"http://{s}.www.toolserver.org/tiles/bw-mapnik/{z}/{x}/{y}.png",
        "options":{
            "attribution":"&copy; <a href=\"http://www.openstreetmap.org/copyright\">OpenStreetMap</a> contributors"
        }
    },
    "osm-de":{
        "url":"http://{s}.tile.openstreetmap.de/tiles/osmde/{z}/{x}/{y}.png",
        "options":{
            "attribution":"&copy; <a href=\"http://www.openstreetmap.org/copyright\">OpenStreetMap</a> contributors."
        }
    },
    "osm-hot":{
        "url":"http://{s}.tile.openstreetmap.fr/hot/{z}/{x}/{y}.png",
        "options":{
            "attribution":"&copy; <a href=\"http://www.openstreetmap.org/copyright\">OpenStreetMap</a> contributors. Tiles courtesy of <a href=\"http://hot.openstreetmap.org/\" target=\"_blank\">Humanitarian OpenStreetMap Team</a>"
        }
    },
    "opensea":{
        "url":"http://tiles.openseamap.org/seamark/{z}/{x}/{y}.png",
        "options":{
            "attribution":""
        }
    },
    "thunder-cycle":{
        "url":"http://{s}.tile.thunderforest.com/cycle/{z}/{x}/{y}.png",
        "options":{
            "attribution":"Maps &copy; <a href=\"http://www.thunderforest.com\">Thunderforest</a>, Data &copy; <a href=\"http://www.openstreetmap.org/copyright\">OpenStreetMap</a> contributors"
        }
    },
};
var edit_map_settings = function edit_search_settings(current_data) {
    var res = Promise.Deferred();
    var cdata = ko.toJS(current_data);
    var dialog = uly.dialogs.execute($("#map-settings-editor-tmpl").html(), {
        "title":_("map_title_edit_map_configuration", "Edit Map Configuration")
    }, cdata).done(function([result]) {
        res.resolve({
            "contextual":ko.unwrap(result.contextual) || false,
            "zoom":ko.unwrap(result.zoom) || 3,
            "filter":ko.unwrap(result.filter) || null,
            "show_user":ko.unwrap(result.show_user) || false,
            "tiles":ko.unwrap(result.tiles) || DEFAULT_TILES
        });
    }).fail(res.reject);
    return res.promise();
};

var user_location = null;
var tracker = null;
var track_count = 0;

if (navigator.geolocation) {
    var set_user_position = function(position) {
        console.log("got position:", position);
        user_location = position.coords;
        uly.publish("user.position.changed", user_location);
    };

    var update_user_tracking = function track_user(track_on) {
        if (track_on) {
            track_count++;
        }
        else {
            track_count--;
        }
        if (track_count > 0 && !tracker) {
            tracker = navigator.geolocation.watchPosition(set_user_position, function() { console.error("error with position tracking:", arguments); },{
                maximumAge: 5000
            });
        }
        else
        {
            if (tracker) {
                navigator.geolocation.clearWatch(tracker);
                tracker = null;
            }
            track_count = 0;
        }
    };

    uly.geo = {
        track_user: function track_user() {
            update_user_tracking(true);
        },
        release_track: function() {
            update_user_tracking(false);
        },
        get_position: function() {
            if (user_location)
                return user_location;
            return null;
        },
        get_current_position: function() {
            var res = Promise.Deferred();

            if (tracker && user_location) {
                res.resolve(user_location);
            }
            else {
                navigator.geolocation.get_current_position(function(position) {
                    user_location = position.coords;
                    uly.publish("user.position.changed", user_location);
                    res.resolve(user_location);
                }, function(error) {
                    var info = "";
                    switch(error.code) {
                    case error.TIMEOUT:
                        info += _("map_timeout", "Timeout !");
                        break;
                    case error.PERMISSION_DENIED:
                        info += _("map_permission_has_not_been_granted", "Permission has not been granted");
                        break;
                    case error.POSITION_UNAVAILABLE:
                        info += _("map_location_unavailable", "Location unavailable");
                        break;
                    case error.UNKNOWN_ERROR:
                        info += _("map_unknown_error", "Unknown error");
                        break;
                    }
                    res.reject(error);
                }, { "timeout":5000, maximumAge:30000 });

            }
            return res.promise();
        }
    };
}
else
{
    uly.geo = {
        track_user: function() {},
        release_track: function() {},
        get_position: function() { return null; },
        get_current_position: function () {
            var def = Promise.Deferred();
            def.reject(false);
            return def.promise();
        }
    };
}


ko.bindingHandlers.map = {
    custom_marker : cilogi.L.Marker.extend({
        options:{
            data:{}
        }
    }),
    refresh_results: function(elt, map, query, map_details, latitude, longitude, not_include, context){
        var l = map.getBounds(),
            $query = $.extend(true, {}, query),
            create_marker = function(map, data){
                data["url"] = data["unique_id"].replace("#", "/");
                var marker = new ko.bindingHandlers.map.custom_marker([
                    data.lat, data.lng
                ],{
                    title: data.title,
                    alt : data.title,
                    data : data,
                    fontIconColor : data.model_colour || "blue",
                    fontIconName : "<i class=\"fa "+data.model_icon+"\">",
                    fontIconFont : "awesome",
                    fontIconSize : 1,
                    opacity: 1
                });
                map.markers.push(marker);
                marker.on("click", function(){
                    var event = this.options.data;
                    var result = new uly.page.searchify_item(event);
                    
                    // result["timers"] = ko.observableArray([]);
                    // result["actions"] = ko.observableArray([]);
                    // HalResource(this.options.data).follow_with_cache("uly:actions",uly.api.action_cache).done(function(actions) {
                    //     result["actions"](uly.actions.classifyActions(actions, event, true));
                    // });
                    // HalResource(event).follow("timers").done(function(timers) {
                    //     result["timers"](timers);
                    // }).always(function(){
                        var ctx = context.createChildContext(result);
                        $(map_details).removeClass("hidden");
                        ko.renderTemplate("search-result-tmp", ctx/*{results:[result]}*/, {}, map_details, "replaceChildren");
                    // });
                });
                map.drawn_items.addLayer(marker);
                return marker;
            };
        for (var q=0;q<query["fq"].length;q++){
            $query["fq"][q] = query["fq"][q].replace(
                /\{north\}/g,l.getNorth()
            ).replace(
                /\{south\}/g,l.getSouth()
            ).replace(
                /\{west\}/g,l.getWest()
            ).replace(
                /\{east\}/g,l.getEast()
            );
        }
        uly.api.start().follow("uly:search").follow("uly:results", { "q": $query || {} }).follow("item").done(function(data) {
            if (map.markers && map.markers.length){
                for (var i in map.markers){
                    map.removeLayer(map.markers[i]);
                    delete map.markers[i];
                }
            }else if (!map.markers) map.markers = [];

            if (map.drawn_items){
                map.removeLayer(map.drawn_items);
            }
            map.drawn_items = new L.MarkerClusterGroup({

            });
            map.addLayer(map.drawn_items);
            var ids = [];
            for (var i in data){
                if (not_include == undefined || (not_include && not_include != data[i].id)){
                    create_marker(map, data[i]);
                    ids.push(data[i].unique_id);
                }
            }

            //subscribe to changes
            map.previous_data = uly.bulkSubscribeToChange(ids, map.previous_data || null, function() {
                uly.utils.throttle(elt, function() {
                    ko.bindingHandlers.map.refresh_results(elt, map, query, map_details, latitude, longitude, not_include, context);
                }, 500);
            }, elt);


        }).fail(function(result) {
            //boh
        });
    },
    "init":function(elt, va, bindings, model, context) {
        var widget_model = ko.unwrap(bindings().widget);
        var settings = ko.unwrap(va());
        var map_details = $(elt).next(".map-details")[0];
        settings.filter = "lat:[{south} TO {north}] AND lng:[{west} TO {east}]";
        var query = uly.utils.filter_search_by_page({}, settings, {}, context);
        query["page_size"] = 1000;
        $(elt).attr({"style":"height:500px"});
        var latitude, longitude,
            entity = ko.toJS(uly.page.page_resource),
            userprofile,
            create_marker = false;
        if (entity && entity.lat && entity.lng){
            latitude = entity.lat;
            longitude = entity.lng;
            create_marker = true;
        }else{
            userprofile = ko.toJS(uly.page.userprofile);
            if (userprofile && userprofile.lat && userprofile.lng){
                latitude = userprofile.lat;
                longitude = userprofile.lng;
            }else{
                latitude = 51.5072;
                longitude = 0.1275;
            }
        }
        var map = L.map(elt).setView([latitude, longitude], settings.zoom);
        if (settings.show_user) {
            uly.geo.track_user(true);
            var user_marker = null;
            uly.subscribe("user.position.changed", function(topic, position) {
                if (user_marker) {
                    map.removeLayer(user_marker);
                    user_marker = null;
                }
                user_marker = new ko.bindingHandlers.map.custom_marker([
                    position.latitude, position.longitude
                ], {
                    "title":_("map_title_user", "User"),
                    "alt":_("map_alt_user", "User"),
                    "fontIconColor": "jacksons-purple",
                    "fontIconName":"<i class='fa fa-user'></i>",
                    "fontIconFont":"awesome",
                    "fontIconSize":1,
                    "opacity":1
                });
                map.addLayer(user_marker);
            }, elt);
            ko.utils.domNodeDisposal.addDisposeCallback(elt, function() {
                uly.geo.track_user(false);
            });
        }
        if (create_marker){
            var marker = new ko.bindingHandlers.map.custom_marker([
                latitude, longitude
            ],{
                title: entity.title,
                alt : entity.title,
                data : entity,
                fontIconColor : entity.model_colour || "blue",
                fontIconName : "<i class=\"fa fa-star\">",
                fontIconFont : "awesome",
                fontIconSize : 1,
                opacity: 1
            });
            map.addLayer(marker);
        }
        //L.tileLayer('http://{s}.www.toolserver.org/tiles/bw-mapnik/{z}/{x}/{y}.png')http://{s}.tile.osm.org/{z}/{x}/{y}.png'
        var tiles = tile_layers[settings.tiles || DEFAULT_TILES];
        L.tileLayer(tiles.url, tiles.options).addTo(map);
        ko.bindingHandlers.map.refresh_results(elt, map, query, map_details, latitude, longitude, entity ? entity.id : null, context);
        map.on("dragend zoomend", function(){
            //TODO: why this ? if (settings.zoom < 10  || map.getZoom() < 10){
            uly.utils.throttle(elt, function() {
                ko.bindingHandlers.map.refresh_results(elt, map, query, map_details, latitude, longitude, entity ? entity.id : null, context);
            }, 500);
            //}
        });
        $(elt).resize(function() { map.invalidateSize(); });
        $(elt).data("leafletmap", map);
        uly.publish("widget.active", elt);
    }
};
function ensureSettingsComplete(origSettings) {
    var settings = ko.unwrap(origSettings);
    var found = false;
    $.each({
        "filter": null,
        "zoom": 12,
        "contextual": false,
        "show_user": false,
        "tiles": DEFAULT_TILES
    }, function(key, value) {
        if (typeof settings[key] == "undefined") {
            settings[key] = value;
            found = true;
        }
    });
    return [settings, found];
}

ko.bindingHandlers.mapwidget = {
    "initial_value":function(){
        var data = {
            "filter":ko.observable(null),
            "zoom":ko.observable(12),
            "contextual":ko.observable(false),
            "show_user":ko.observable(false),
            "tiles":ko.observable(DEFAULT_TILES)
        };
        var init_def = Promise.Deferred();
        edit_map_settings(data).done(function(result) {
            data.filter(result.filter);
            data.zoom(result.zoom);
            data.contextual(result.contextual || false);
            data.show_user(result.show_user);
            data.tiles(result.tiles);
            init_def.resolve(data);
        }).fail(init_def.reject);
        return init_def;
    },
    "init":function(elt, va, bindings, model, context) {
        var widget_model = ko.unwrap(va());
        //widget_model.show_header(false);
        widget_model.icon("fa fa-map-marker");
        widget_model.error = ko.observable(null);
        var res = ensureSettingsComplete(ko.unwrap(widget_model.settings));
        var settings = res[0], modified = res[1];
        if (modified) {
            widget_model.settings(settings);
        }

        var settings_menu = widget_model.settings_menu;
        settings_menu.push({
            "caption":_("map_caption_modify", "Modify"),
            "icon":"fa-edit",
            "action":function(e){
                var component_type = settings.compact ? "sidebar" : "page";
                edit_map_settings(settings).done(function(result) {
                    var new_settings = $.extend({}, settings, {
                        filter: result.filter,
                        zoom: result.zoom,
                        contextual: result.contextual || false,
                        show_user: result.show_user,
                        tiles: result.tiles || DEFAULT_TILES
                    });
                    widget_model.settings(new_settings);
                    uly.publish(component_type + ".savesettings");
                });
            },
            "colour":"primary",
            "permission": "editpage"
        });

        var $map_elt = $(elt).children(".map");
        var childContext = context.extend({"widget_model":widget_model});
        ko.applyBindingsToDescendants(childContext, elt);
        uly.subscribe("widget.remove", function(topic, widget) {
            if (widget != elt)
                return false;
            ko.removeNode(elt);
        }, elt);

        return { controlsDescendantBindings: true };
    },
    "update":function(elt, va, allbindings, model, context) {
        var widget_model = ko.unwrap(va());
        var map_settings = ko.unwrap(widget_model.settings);
        var updating = $(elt).children(".map").data("map-updating");
        if (updating)
            return;
        uly.publish("widget.loading", elt);
        widget_model.title.valueHasMutated();
    }
};
uly.widgets.register({
    "type":"map",
    "caption":_("map_caption_map", "Map"),
    "description":_("map_description_a_map_widget", "A map widget"),
    "icon":"fa-map-marker",
    "init":ko.bindingHandlers.mapwidget.initial_value,
    "colour":"apple",
    "actions":[{
        "caption":_("map_caption_settings", "Settings"),
        "icon":"fa-cog",
        "action":function(e){
            return false;
        },
        "colour":"apple",
        "permission": "editpage"
    }]
});
